import { useI18nContext } from "@root/utils/organisation";
import { useMemo } from "react";

export const useCerLegacyCard = (startDate: Date, endDate: Date) => {
  const { timeZone } = useI18nContext();

  const cerStartDate = useMemo(() => {
    return startDate.toLocaleString("fr-FR", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      timeZone,
    });
  }, [startDate, timeZone]);

  const cerEndDate = useMemo(() => {
    return endDate.toLocaleString("fr-FR", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      timeZone,
    });
  }, [endDate, timeZone]);

  return {
    cerStartDate,
    cerEndDate,
  };
};
